var _ref2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAttach = function SvgAttach(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 10,
      height: 19,
      viewBox: "0 0 10 19",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M6.27613 4.202L6.21774 13.5666L6.21774 13.5666C6.2147 14.0959 5.78222 14.5285 5.25248 14.5318C4.72374 14.5352 4.29822 14.1096 4.30185 13.5812L4.30185 13.5812L4.3413 7.23348L4.34193 7.13228L4.24073 7.13286L3.18279 7.13885L3.08397 7.13941L3.08336 7.23823L3.05059 12.5286L3.05059 12.5287L3.04357 13.5862L3.04296 13.678L3.04993 13.6786C3.10767 14.8432 4.06497 15.7635 5.24739 15.7567L5.24742 15.7567C6.42964 15.7495 7.39777 14.8176 7.46847 13.6512L7.47434 13.6505L7.47511 13.562L7.55797 4.08388L7.55798 4.08334C7.56416 2.23743 6.07322 0.746465 4.22762 0.753002C2.38259 0.759535 0.882135 2.25998 0.875593 4.10501C0.875593 4.10502 0.875593 4.10502 0.875593 4.10503L0.871583 5.18571V5.18573L0.841148 13.8288L0.840725 13.949L0.844903 13.9483C0.917632 16.3192 2.85717 18.2101 5.24783 18.2014C7.60136 18.1931 9.5291 16.349 9.67437 14.0303L9.68342 14.0393L9.68425 13.7991L9.71029 6.23704L9.61029 6.2367L9.71029 6.23704L9.71396 5.15668L9.7143 5.05596L9.61359 5.05634L8.53357 5.06035L8.43431 5.06072L8.43394 5.15998L8.42993 6.23999L8.42994 6.24001L8.4032 13.8028V13.8028C8.39773 15.5372 6.98597 16.949 5.25081 16.9551C3.51623 16.9613 2.11536 15.5604 2.12151 13.8258L2.15217 5.18248L2.15217 5.18247L2.15587 4.18562L2.16293 4.18434L2.15768 4.09587L2.15585 4.06495C2.16167 2.92801 3.08695 2.00383 4.22425 1.99964C5.36076 1.99546 6.27932 2.91276 6.27721 4.04883L6.27484 4.07844L6.26484 4.20366L6.27613 4.202Z",
      fill: "#041F47",
      stroke: "#041F47",
      strokeWidth: 0.2
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgAttach, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/attach.053e3f59.svg";
export { ForwardRef as ReactComponent };